import React from 'react';
import PropTypes from 'prop-types';
import Raven from 'raven-js';
import Alert from 'react-s-alert';

// https://github.com/websockets/ws/wiki/Websocket-client-implementation-for-auto-reconnect
class ReconnectingWebSocket extends React.PureComponent {
  state = { socket: this.createSocket() };

  componentDidMount() {
    this.addAllListeners();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.socket !== prevState.socket) {
      this.addAllListeners();
    }
  }

  componentWillUnmount() {
    this.removeAllListeners();
    this.state.socket.close();

    if (this.alertId) Alert.close(this.alertId);
  }

  handleOpen = () => {
    if (this.alertId) Alert.close(this.alertId);
  }

  handleMessage = (event) => {
    let response;
    try {
      response = JSON.parse(event.data);
    } catch (error) {
      Raven.captureException(error, { extra: event });
      return;
    }

    this.props.onMessage(response);
  }

  handleClose = (event) => {
    if (event.code === 1000) return; // CLOSE_NORMAL
    this.reconnect();
  }

  handleError = () => {
    if (!this.alertId) {
      this.alertId = Alert.error(`Ошибка соединения с ${this.props.path}`, { timeout: 'none' });
    }

    Raven.captureException('ReconnectingWebSocket handleError', { extra: this.props });
  }

  handleReconnect = () => {
    this.setState({ socket: this.createSocket() });
  }

  createSocket() {
    const url = new URL(this.props.path, window.location.href);
    url.protocol = url.protocol.replace('http', 'ws');
    return new WebSocket(url.href);
  }

  reconnect() {
    this.removeAllListeners();

    const AUTO_RECONNECT_INTERVAL = 5000; // ms
    setTimeout(this.handleReconnect, AUTO_RECONNECT_INTERVAL);
  }

  addAllListeners() {
    this.state.socket.addEventListener('open', this.handleOpen);
    this.state.socket.addEventListener('message', this.handleMessage);
    this.state.socket.addEventListener('close', this.handleClose);
    this.state.socket.addEventListener('error', this.handleError);
  }

  removeAllListeners() {
    this.state.socket.removeEventListener('open', this.handleOpen);
    this.state.socket.removeEventListener('message', this.handleMessage);
    this.state.socket.removeEventListener('close', this.handleClose);
    this.state.socket.removeEventListener('error', this.handleError);
  }

  render() {
    return this.props.children(this.state.socket);
  }
}

ReconnectingWebSocket.propTypes = {
  path: PropTypes.string,
  children: PropTypes.func,
  onMessage: PropTypes.func,
};

ReconnectingWebSocket.defaultProps = {
  path: '',
  children: () => null,
  onMessage: () => {},
};

export default ReconnectingWebSocket;
